import React from 'react'

export const Footer = () => {
  return (
    <div class='footer'>
      <b>Disclaimer:</b>
      <ol>
        <li>No signup required</li>
        <li> For now there's no securitey to any account.</li>
        <li> Tip: Press enter to login. or simply use 'sahil'.</li>
        <li> Changing db only works for when you set valid jsonbackendserver in the 'Input backend database' field and press enter.</li>
        <li> This axios playground perfectly works for locally saving to broser too.</li>
        <li> Please allow 2 seconds after typing into request code area to get it saved to localStorage to browser.</li>
        <li> Tip: For testing use either 'sahil' or 'guest'.</li>
      </ol>
      <br />
      Happy Hacking!
      <br />
      <br />
    </div>
  )
}
